import { render, staticRenderFns } from "./ChatRefSystem.vue?vue&type=template&id=27cfbf15&"
import script from "./ChatRefSystem.vue?vue&type=script&lang=js&"
export * from "./ChatRefSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports